import { get, post } from 'api/client';
import config from 'config';
import {
  GetConnectedAccountsResponse,
  SwitchAccountResponse,
} from '../types/accountSwitcher';

export const AccountSwitcherApi = {
  getConnectedAccounts: (): Promise<GetConnectedAccountsResponse> =>
    get('/cognito/accounts', {
      baseURL: config.API_SERVICE_ENDPOINT,
    }),

  switchAccount: (accountId: number): Promise<SwitchAccountResponse> =>
    post(
      '/cognito/switch-account',
      { account_id: accountId },
      { baseURL: config.API_SERVICE_ENDPOINT },
    ),
};
